import {useLocation, useNavigate} from 'react-router-dom'
import {useState} from 'react'
import back from '../../../_metronic/assets/custom-icons/back.png'
import {setTitle} from '../../redux/reducers/mainSlice'
import {useDispatch} from 'react-redux'
import formatDate from '../../../_metronic/helpers/formatDate'
import moment from 'moment'
import profileIcon from '../../../_metronic/assets/custom-icons/profile.png'
import {Badge} from 'react-bootstrap'
import api from '../../../_metronic/helpers/api'
import {showAlert} from '../../redux/reducers/alertSlice'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import useUtils from './useUtils'

const ViewUser = ({className}) => {
  const [active, setActive] = useState(null)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const {fetchUser} = useUtils()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {state} = useLocation()
  dispatch(setTitle('User'))
  const [values, setValues] = useState(state?.values)

  const handleDelete = (id, isActive) => {
    setSelectedId(id)
    setActive(isActive)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      const response = await api.patch(`/user/${selectedId}`, {isActive: active})
      if (response.data.status) {
        if (state) {
          dispatch(
            showAlert({message: `Successfully Activated`, variant: 'success', timeout: 1000})
          )
        } else {
          dispatch(
            showAlert({message: `Successfully Deativated`, variant: 'success', timeout: 1000})
          )
        }
      }
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setModalVisible(false)
      getSingleUser(selectedId)

      setActive(null)
    }
  }

  const getSingleUser = async (id) => {
    console.log('here')
    try {
      const result = await fetchUser(id)
      setValues(result)
      setSelectedId(null)
    } catch (error) {
      console.error('Error loading data:', error)
    }
  }

  const handleBlackForceMemberChange = async (e) => {
    const isChecked = e.target.checked;
    try {
      const response = await api.patch(`/user/${values.id}`, { blackForceMember: isChecked });
      if (response.data.status) {
        dispatch(
          showAlert({ message: `Successfully updated Black Force Member status`, variant: 'success', timeout: 2000 })
        );
        setValues({ ...values, blackForceMember: isChecked });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <div className={`card ${className} ms-4`}>
        <img
          onClick={() => navigate('/userlist')}
          style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          src={back}
          className='me-2'
        />
        <div className='pt-10 px-4 mb-3' style={{ fontSize: '14px' }}>
          <div className='d-flex justify-content-between'>
            <div className='d-flex align-items-start flex-wrap gap-10'>
              <img
                style={{ height: '340px', width: '400px', objectFit: 'contain', display: 'block' }}
                src={profileIcon}
              />
              <div className='d-flex flex-column t-14 gap-5 mt-2'>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Full Name:</div>
                  <div>{values?.name}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Email:</div>
                  <div>{values?.email}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Role:</div>
                  <div>{values?.role}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Status:</div>
                  <Badge
                    bg={values?.isActive === true ? 'success' : 'warning'}
                    text={values?.isActive !== true ? 'dark' : ''}
                  >
                    {values?.isActive === true ? 'Active' : 'Not Active'}
                  </Badge>
                </div>
                <div className='d-flex gap-5 align-items-center'>
                  <div className='fw-bold m-0'>Black Force Member:</div>

                  <label className='form-check d-inline-block form-check-custom form-check-solid form-switch'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={values.blackForceMember}
                      onChange={handleBlackForceMemberChange}
                    />
                  </label>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Total Referrals:</div>
                  <div>{values?.totalreferrals ?? 0}</div>
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Last Login:</div>
                  {values?.lastLogin ? formatDate(values?.lastLogin) : 'N/A'}
                </div>
                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Subscription:</div>
                  <div>{values?.subscription ? values?.subscription?.name : 'Unsubscribed'}</div>
                </div>

                <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Join Date:</div>
                  {values?.lastLogin
                    ? moment(values?.createdAt).format('DD MMM YY [at] h:mm A')
                    : 'N/A'}
                </div>
              </div>
            </div>

            <div>
              <button
                type='button'
                className='btn btn-primary ms-2 mt-2 me-2 text-nowrap'
                onClick={() => handleDelete(values.id, !values?.isActive)}
              >
                {values?.isActive ? 'Deactivate User' : 'Activate User'}
              </button>

              {/*{values.status !== 'published' && (
                <button
                  type='button'
                  className='btn btn-primary ms-2 mt-2 me-2'
                  onClick={() => submitModule(values.id)}
                >
                  Publish Program
                </button>
              )}*/}
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmation
        isVisible={modalVisible}
        message={
          active ? 'Are you sure you want to activate?' : 'Are you sure you want to deactivate?'
        }
        onConfirm={confirmDelete}
        onCancel={() => setModalVisible(false)}
      />
    </>
  )
}

export {ViewUser}
